
import { navThemeControls } from '~/mixins/navigation/themeChangeOnScroll'

export default {
  mixins: [navThemeControls],
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$matchMedia('sm')) {
        this.setNavThemeChangeOnScroll(this.blok.nav_theme)
      }
    })
  },
}
